import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { PromptBoxModel } from './prompt-box.model';

@Component({
  selector: 'app-prompt-box',
  templateUrl: './prompt-box.component.html',
  styleUrls: ['./prompt-box.component.scss'],
})

export class PromptBoxComponent implements OnInit {

  model: PromptBoxModel = new PromptBoxModel();

  @ViewChild('confirmButton', { static: true }) confirmButton: ElementRef;
  @ViewChild('cancelButton', { static: true }) cancelButton: ElementRef;
  @ViewChild('inputText', { static: true }) inputText: ElementRef;

  onClick(confirmed: boolean): void {

    const textValue = this.inputText.nativeElement.value;

    if (confirmed == true) {

      if (this.isInvalid()) { return; }

      if (this.model.onConfirm != null) this.model.onConfirm(textValue);
      this.dialogRef.close(textValue);
    } else {
      if (this.model.onCancel != null) this.model.onCancel();
      this.dialogRef.close()
    }
  }

  constructor(
    public dialogRef: MatDialogRef<PromptBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PromptBoxModel
  ) { }

  ngOnInit(): void {
    this.model = this.data;
    if (this.data.showCancelButton == undefined || this.data.showCancelButton == null) this.model.showCancelButton = true;
  }

  isNull(value) {
    if (typeof value == 'undefined' || value == null) return true; else return false;
  }

  isInvalid(): boolean {
    const textValue = this.inputText.nativeElement.value;
    return this.model.isRequired && (this.isNull(textValue) || textValue.trim().length == 0);
  }
}

export enum PromptBoxColor {
  error = '#f24c4c',
  warn = '#F2A51A',
  info = '#5AB8CA'
}

export enum PromptBoxDefaultButton {
  confirmar,
  cancelar
}
